import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getAutocompleteSearchUrl } from "../../../helpers/helpers";
import { useAutocompleteSuggestions } from "../../../hooks/useAutocompleteSuggestions";
// --- NEW --- (Assuming this is your http helper, adjust the path if needed)

const SearchBanner = () => {
  const [searchQuery, setSearchQuery] = useState({
    query: "",
    search_type: "address",
  });
  const navigate = useNavigate();

  const {
    suggestions,
    setSuggestions,
    isSuggestionsLoading,
    showSuggestions,
    setShowSuggestions,
  } = useAutocompleteSuggestions({
    query: searchQuery.query,
    type: searchQuery.search_type,
  });
  const autocompleteRef = useRef(null); // Ref for the search container

  // --- NEW: useEffect to handle clicks outside the autocomplete dropdown ---
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (autocompleteRef.current && !autocompleteRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSuggestionClick = (suggestion) => {
    const text = suggestion?.suggestion ?? "";
    window.location.href = getAutocompleteSearchUrl(suggestion);

    setSearchQuery({ ...searchQuery, query: text });

    // Hide the dropdown
    setShowSuggestions(false);
    setSuggestions([]);
  };

  // This is the original submit handler for pressing Enter or clicking the search button
  const handleSubmit = (event) => {
    event.preventDefault();
    // Hide suggestions on submit
    setShowSuggestions(false);
    navigate(
      `/search-property?search_query=${searchQuery.query}&search_type=${searchQuery.search_type}`
    );
  };

  // --- MODIFIED: Clear search query when changing search type ---
  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "search_type") {
      // If the search type is changed, clear the query input
      setSearchQuery({ query: "", search_type: value });
    } else {
      setSearchQuery({ ...searchQuery, [name]: value });
    }
  };

  return (
    <>
      <section className="property_listing_search">
        <div className="contain">
          <h3>Search properties</h3>
          <div className="hide_cell_link_advance">
            <Link to="/search-property">Advanced Property Search</Link>
          </div>
          {/* --- NEW: Added ref to this container --- */}
          <div className="search_relative" ref={autocompleteRef}>
             {/* --- NEW: Styles for the Autocomplete Dropdown --- */}
            <style>{`
              .search_relative {
                position: relative;
              }
              .autocomplete-suggestions {
                position: absolute;
                top: 100%;
                left: 0;
                right: 0;
                background-color: #ffffff;
                border: 1px solid #ccc;
                border-radius: 4px;
                list-style-type: none;
                margin: 5px 0 0;
                padding: 0;
                max-height: 350px;
                overflow-y: auto;
                z-index: 1001; /* Ensure it appears above other content */
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
                text-align: left;
              }
              .autocomplete-suggestions li {
                padding: 12px 18px;
                cursor: pointer;
                font-size: 15px;
                border-bottom: 1px solid #eee;
              }
              .autocomplete-suggestions li:hover {
                background-color: #f5f5f5;
              }
              .autocomplete-suggestions li:last-child {
                border-bottom: none;
              }
              .autocomplete-suggestions li.loading,
              .autocomplete-suggestions li.no-results {
                color: #888;
                font-style: italic;
                cursor: default;
              }
              .autocomplete-suggestions li.loading:hover,
              .autocomplete-suggestions li.no-results:hover {
                  background-color: transparent;
              }
            `}</style>
            <form onSubmit={handleSubmit}>
              <select
                name="search_type"
                className="input"
                value={searchQuery.search_type} // --- MODIFIED: Controlled component
                onChange={handleChange}
              >
                <option value="address">Address</option>
                <option value="city_state">City, State</option>
                <option value="zipcode">Zipcode</option>
                <option value="owner_name">Property Owner</option>
              </select>
              <input
                type="text"
                placeholder="Search by address, location, or owner"
                className="input"
                name="query"
                value={searchQuery.query} // --- MODIFIED: Controlled component
                onChange={handleChange}
                autoComplete="off" // --- NEW: Prevent browser autocomplete
                required
              />
              <button type="submit" className="site_btn only_search_icon">
                <span className="hide_sm_src">Search</span>{" "}
                <span className="hide_big_src">
                  <img src="/images/search_green.svg" alt="" />
                </span>
              </button>
            </form>
            
            {/* --- NEW: The autocomplete suggestions dropdown --- */}
            {showSuggestions && (
              <ul className="autocomplete-suggestions">
                {isSuggestionsLoading ? (
                  <li className="loading">Loading...</li>
                ) : suggestions.length > 0 ? (
                  suggestions.map((item, index) => (
                    <li 
                      key={`${item.property_id}-${index}`} 
                      onClick={() => handleSuggestionClick(item)}
                    >
                      {item.suggestion}
                    </li>
                  ))
                ) : (
                  // Show "No results" only if not loading and input has text
                  searchQuery.query && searchQuery.query.trim().length > 1 && <li className="no-results">No results found</li>
                )}
              </ul>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default SearchBanner;
